export class TbUtility {
  static hexToRgb(hexColor: string, opacity: number): string {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
    return result
      ? `rgba(${[parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), opacity].join(',')})`
      : null;
  }

  static rgbToHex(rgb): string {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
    return rgb && rgb.length === 4
      ? '#' +
          ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
          ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
          ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2)
      : '';
  }

  static extractOpacity(color: string): string {
    return color.replace(/^.*,(.+)\)/, '$1');
  }

  static get randomIdAsNumber(): number {
    return Math.floor(Math.random() * 1000000);
  }

  /**
   * @param adjust > 0 -> lighten the color, adjust < 0 -> darken the color
   * @param hexColor: color in hex format
   */
  static adjustColor(hexColor: string, adjust: number): string {
    return (
      '#' +
      hexColor
        .replace(/^#/, '')
        .replace(/../g, color =>
          ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + adjust)).toString(16)).substr(-2),
        )
    );
  }
}
